import React, { useEffect, useState } from "react";
import { Tabs } from "../../layout";
import InqDetails from "./InqDetails";
import InqFollowUps from "./InqFollowUps";
import { useParams } from "react-router-dom";
import { API, actions, endpoints } from "../../api/api";
import { useTranslation } from "react-i18next";

const ViewInquiry = () => {
  const { id } = useParams();
  const [values, setValues] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    id &&
      API(endpoints.Inquiry + actions.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = res.result;
          setValues((x) => ({ ...val }));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <Tabs header={[{ label: t("Details") }, { label: t("FollowUp") }]}>
        <InqDetails val={values} />
        <InqFollowUps val={values} />
      </Tabs>
    </>
  );
};

export default ViewInquiry;
